<template>
    <div id="body" >
        <Logo />
        <Toast />
        <div id="signin" class="grid grid-flow-col grid-cols-2 gap-10 items-center;">
            <SideImage />
        <div class="form-box">
            
            <h3>Sign In</h3>
                <p>Please Sign In to Continue to BloodHQ </p>
                
                <form action="#" @submit.prevent="submit">
                    <div class="input-box">
                        <label for="email">E-mail Address</label>
                        <input type="email" name="email" required='required' v-model='form.email' placeholder="johndoe@gmail.com" class="box" id="email" />
                    </div>
                    
                    <div class="input-box">
                        <label for="password">Password</label>
                        <Password v-model="form.password" toggleMask ></Password>
                    </div>
                    
                    <a href="#" class="float-right font-medium">Forgot Password ?</a>
                    <div class="submit-button ">
                        <button class="box" v-if="isSpin"><ProgressSpinner style="width:2em;height:auto; stroke: white"/></button>
                        <button class="box" v-else><span >Continue</span></button>
                    </div>
                        <a href="#" class="float-left font-medium">Don't have an account? <router-link to="/createaccount"><span class="text-red-400">Signup</span></router-link></a>
                </form>
        </div>
        </div>
        
    </div>
</template>
<script>
import ProgressSpinner from 'primevue/progressspinner';
import Toast from 'primevue/toast';
import {mapGetters} from 'vuex'
import axios from 'axios'
import {mapActions} from 'vuex' 
import Password from 'primevue/password';
import Logo from '../components/Logo';
import SideImage from '../components/SideImage';

export default {
    name: 'Signin',
    data(){
        return {
            isImage: '',
            isClass: '',
            isSpin: false,
            form: {
                email: '',
                password: ''
            }
        }
    },
    computed: {
        ...mapGetters({
            message : 'auth/message',
            authenticated : 'auth/authenticated'
        }),
    },
    methods:{
        ...mapActions({
            signIn: 'auth/signIn'
        }),
        leto(){
            console.log('let')
        },
        isAuthenticated(){
         if(this.authenticated){
           this.$router.replace({
                    path: 'dashboard',

                })
         }
         else {

         }
       },
        submit(){
             this.isSpin = !this.isSpin;
            this.signIn(this.form).then(() => {
                this.$router.replace({path: '/dashboard' }) }).catch(() => {
                     this.$toast.add({severity:'error', detail:'Incorrect Credentials', life: 3000});
                     this.isSpin = !this.isSpin;
                console.log('failed')
            })
        }
        }
    ,
    mounted() {
    this.isAuthenticated();
    
    
  },
    components: {
        SideImage,
       
        Password,
        Logo,
        Toast,
        ProgressSpinner
    }
}
</script>
<style lang="scss" >

@import '../assets/styles/sign';
.p-progress-spinner {
    width: 2em !important;
    height: auto !important;
}
@keyframes p-progress-spinner-color {
     0% {
        stroke: white ;
    }
   100% {
        stroke: white ;
    }
}
#body {
    font-family: 'DM Sans', sans-serif;
     width: 90%;
    font-size: 90%;
    margin: 0 auto;
}
.p-password input.p-inputtext {
        height: 3.5em;
        width: 100%
    }
    .logo {
    margin: 3em 0 !important;
}
    @media (max-width: 995px) {
    #signin {
        display: block;
        .ads {
            display: none
        }
    }
}
</style>